<template>
  <li>
    <a href="javascript:void(0);" class="generatelink grid between cross-center" @click="showForm">
      <span class="sidebar-title">Cоздать ссылку</span>
      <b-icon icon="link-variant" custom-size="mdi-18px"></b-icon>
    </a>
    <el-dialog
      :visible.sync="generateVisible"
      v-model="generatelink"
      :lock-scroll="true"
      :append-to-body="true"
      class="generatelinkForm"
      :class="{ fz: terminalReceipt(form.terminal_id) }"
      @open="hideScroll"
      @close="showScroll"
    >
      <span slot="title" class="dialog-header">
        <span class="title">Ссылка на оплату</span>
      </span>
      <div class="grid">
        <div class="u-16">
          <el-form
            ref="form"
            status-icon
            :model="form"
            size="small"
            label-position="left"
            label-width="140px"
            :rules="rules"
          >
            <div class="grid">
              <div class="u-16" :class="{ 'u-8-ms left': terminalReceipt(form.terminal_id) }">
                <el-form-item label="Терминал" prop="terminal_id" required>
                  <el-select
                    v-model="form.terminal_id"
                    filterable
                    placeholder="Терминал"
                    clearable
                    value-key="id"
                    @change="changeValue"
                  >
                    <el-option
                      v-for="item in terminalNonPayout"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Сумма" prop="amount" required>
                  <currencyInput v-model.lazy="form.amount" v-on:changeValue="changeValue"></currencyInput>
                </el-form-item>
                <el-form-item label="Номер заказа" prop="merchant_order_id">
                  <el-input v-model="form.merchant_order_id" clearable @input="changeValue"></el-input>
                </el-form-item>
                <div v-if="terminalReceipt(form.terminal_id)">
                  <el-form-item label="Email" prop="emailfz">
                    <el-input v-model.trim="form.emailfz" clearable @input="changeValue"></el-input>
                  </el-form-item>
                  <el-form-item label="ФИО" prop="full_name">
                    <el-input
                      v-model="form.full_name"
                      clearable
                      @keypress.native="onlyLetters"
                      @input="changeValue"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Телефон" prop="phone">
                    <el-input
                      v-model.trim="form.phone"
                      placeholder="79123456789"
                      clearable
                      @keypress.native="onlyNumbers"
                      @input="changeValue"
                    ></el-input>
                  </el-form-item>
                </div>
                <div v-else>
                  <el-form-item label="Email" prop="email">
                    <el-input v-model.trim="form.email" clearable @input="changeValue"></el-input>
                  </el-form-item>
                </div>
                <el-form-item label="Срок оплаты" prop="lifetime">
                  <el-date-picker
                    type="datetime"
                    format="dd.MM.yy HH:mm"
                    placeholder="Выберите дату"
                    v-model="form.lifetime"
                    time-arrow-control
                    :picker-options="pickerOptions"
                    @change="changeValue"
                  ></el-date-picker>
                  <div class="hint">срок оплаты закончится {{ form.lifetime | showLifeTime }}</div>
                </el-form-item>
                <el-form-item label="Комментарий" prop="description">
                  <el-input
                    type="textarea"
                    v-model="form.description"
                    :autosize="{ minRows: 4, maxRows: 6 }"
                    @input="changeValue"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="u-16 u-8-ms right" v-if="terminalReceipt(form.terminal_id)">
                <div v-for="(goods, index) in form.goods" :key="goods.key">
                  <el-form-item
                    label="Товар/услуга"
                    :prop="'goods.' + index + '.name'"
                    :rules="{
                      required: true,
                      message: 'Введите позицию/услугу',
                      trigger: 'blur'
                    }"
                  >
                    <el-input maxlength="128" v-model="goods.name" clearable @input="changeValue"></el-input>
                  </el-form-item>
                  <el-form-item
                    label="Предмет расчета"
                    :prop="'goods.' + index + '.subject_type'"
                    :rules="{
                      required: true,
                      message: 'Выберите предмет расчета'
                    }"
                  >
                    <el-select
                      v-model="goods.subject_type"
                      value-key="id"
                      placeholder="Предмет расчета"
                      clearable
                      @change="changeValue"
                    >
                      <el-option
                        v-for="item in subjectTypes"
                        :key="item.id"
                        :label="item.value"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item
                    label="Способ расчета"
                    :prop="'goods.' + index + '.payment_method'"
                    :rules="{
                      required: true,
                      message: 'Выберите способ расчета'
                    }"
                  >
                    <el-select
                      v-model="goods.payment_method"
                      value-key="id"
                      placeholder="Способ расчета"
                      clearable
                      @change="changeValue"
                    >
                      <el-option
                        v-for="item in paymentMethod"
                        :key="item.id"
                        :label="item.value"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item
                    label="Цена"
                    :prop="'goods.' + index + '.price'"
                    :rules="[
                      {
                        required: true,
                        message: 'Введите цену',
                        trigger: ['blur', 'change']
                      },
                      { validator: checkPrice, trigger: 'submit' }
                    ]"
                  >
                    <currencyInput v-model.lazy="goods.price" v-on:changeValue="changeValue"></currencyInput>
                  </el-form-item>

                  <el-form-item
                    label="Ставка НДС"
                    :prop="'goods.' + index + '.tax'"
                    :rules="{ required: true, message: 'Выберите ставку НДС' }"
                  >
                    <el-select
                      v-model="goods.tax"
                      value-key="id"
                      placeholder="Ставка НДС"
                      clearable
                      class="select-tax"
                      @change="changeValue"
                    >
                      <el-option
                        v-for="item in tax"
                        :key="item.id"
                        :label="item.value"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="Признак агента" :prop="'goods.' + index + '.agent_type'">
                    <el-select
                      v-model="goods.agent_type"
                      value-key="id"
                      placeholder="Признак агента"
                      clearable
                      class="select-tax"
                      @change="changeValue"
                    >
                      <el-option
                        v-for="item in agent_type"
                        :key="item.id"
                        :label="item.label"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item
                    label="Поставщик"
                    :prop="'goods.' + index + '.supplierName'"
                  >
                    <el-input  maxlength="200" v-model="goods.supplier.name" clearable @input="changeValue"></el-input>
                  </el-form-item>
                  <el-form-item
                    label="ИНН"
                    name="inn"
                    :prop="'goods.' + index + '.supplierInn'"
                    :rules="[
                      { validator: checkSupplierINN, trigger: 'submit' }
                    ]"
                  >
                    <el-input
                      maxlength="12"
                      v-model="goods.supplier.inn"
                      clearable
                      @input="changeValue"
                      @keypress.native="onlyNumbers"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Телефон">
                    <el-input
                      class="input-phone"
                      v-model="goods.supplier.phone_numbers"
                      clearable
                      @input="changeValue"
                    ></el-input>
                    <el-button
                      v-if="form.goods.length > 1"
                      @click.prevent="removeGoods(goods)"
                      class="l-margin-10"
                      type="danger"
                      icon="el-icon-delete"
                      size="mini"
                      circle
                    ></el-button>
                    <el-button
                      v-if="index == form.goods.length - 1"
                      type="success"
                      class="l-margin-10"
                      @click="addGoods"
                      icon="el-icon-plus"
                      size="mini"
                      circle
                    ></el-button>
                  </el-form-item>
                  <hr />
                </div>
              </div>
              <el-collapse-transition>
                <div class="u-16" v-show="isVisibleCopy">
                  <hr class="u-16" />
                  <el-input
                    type="textarea"
                    class="linkarea"
                    placeholder="#"
                    disabled
                    v-model="url"
                    :autosize="{ minRows: 1, maxRows: 2 }"
                  ></el-input>
                </div>
              </el-collapse-transition>
              <div class="u-16 grid between end form-buttons">
                <div>
                  <el-form-item>
                    <span class="r-margin-10">Прокси</span>
                    <el-switch v-model="form.proxy"></el-switch>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item>
                    <el-button
                      v-show="isVisibleCopy"
                      type="success"
                      @click="doCopy"
                    >Скопировать ссылку</el-button>
                    <el-button
                      v-show="!isVisibleCopy"
                      type="primary"
                      @click="submitForm('form')"
                      :loading="loading"
                    >Получить ссылку</el-button>
                    <el-button @click="resetForm('form')">Сброс</el-button>
                  </el-form-item>
                </div>
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </li>
</template>

<script>
import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import Vuex from "vuex";
import { mapGetters } from "vuex";
import { _ } from "underscore";
import axios from "axios";
import { apiUrl } from "@/api/apiUrl";

import moment from "moment-timezone";
import currencyInput from "@/components/MoneyInput.vue";
import goods from "../localize/goods";

Vue.use(VueClipboard);

var subjectTypes = [
  { id: 1, value: "Товар" },
  { id: 2, value: "Подакцизный товар" },
  { id: 3, value: "Работа" },
  { id: 4, value: "Услуга" },
  { id: 5, value: "Ставка азартной игры" },
  { id: 6, value: "Выигрыш азартной игры" },
  { id: 7, value: "Лотерейный билет" },
  { id: 8, value: "Выигрыш лотереи" },
  { id: 9, value: "Предоставление РИД" },
  { id: 10, value: "Платеж" },
  { id: 11, value: "Агентское вознаграждение" },
  { id: 12, value: "Выплата" },
  { id: 13, value: "Иной предмет расчета" },
];

var tax = goods.tax

var paymentMethod = [
  { id: 1, value: "Предоплата 100%" },
  { id: 2, value: "Частичная предоплата" },
  { id: 3, value: "Аванс" },
  { id: 4, value: "Полный расчет" },
  { id: 5, value: "Частичный расчет и кредит" },
  { id: 6, value: "Передача в кредит" },
  { id: 7, value: "Оплата кредита" },
];

var agent_type = [
  { id: 1, label: "Банковский платежный агент", value: 1 },
  { id: 2, label: "Банковский платежный субагент", value: 2 },
  { id: 3, label: "Платежный агент", value: 3 },
  { id: 4, label: "Платежный субагент", value: 4 },
  { id: 5, label: "Поверенный", value: 5 },
  { id: 6, label: "Комиссионер ", value: 6 },
  { id: 7, label: "Иной агент ", value: 7 },
];

export default {
  name: "generateLink",
  data() {
    var checkTerminal = (rule, value, callback) => {
      setTimeout(() => {
        if (!value) {
          return callback(new Error("Выберите терминал"));
        } else callback();
      }, 300);
    };
    var checkAmount = (rule, value, callback) => {
      setTimeout(() => {
        if (parseFloat(value) <= 0) {
          return callback(new Error("Сумма не должна быть равной нулю"));
        } else callback();
      }, 300);
    };
    var checkOrder = (rule, value, callback) => {
      setTimeout(() => {
        if (!value) {
          return callback(new Error("Введите номер заказа"));
        } else callback();
      }, 300);
    };
    var checkLifetime = (rule, value, callback) => {
      let lifeTime = new Date(value).getTime();
      let now = Date.now();
      setTimeout(() => {
        if (lifeTime - now < 60) {
          return callback(
            new Error("Срок оплаты не должен быть менее 1 минуты")
          );
        } else callback();
      }, 300);
    };
    var checkEmail = (rule, value, callback) => {
      let re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if (value && value != "") {
        setTimeout(() => {
          if (!re.test(value.toLowerCase())) {
            return callback(new Error("Введите корректный email"));
          } else callback();
        }, 300);
      } else {
        if (rule.field == "email") return callback();
      }
    };
    var checkPhone = (rule, value, callback) => {
      if (value && value != "") {
      }
    };
    return {
      loading: false,
      isVisibleCopy: false,
      url: "",
      subjectTypes: [...subjectTypes],
      paymentMethod: [...paymentMethod],
      tax: [...tax],
      agent_type: [...agent_type],
      form: {
        terminal_id: "",
        merchant_order_id: "",
        amount: "",
        lifetime: moment().add(1, "weeks").second(0).minute(0),
        email: "",
        phone: "",
        full_name: "",
        goods: [
          {
            key: 1,
            name: "",
            price: "",
            subject_type: subjectTypes[0],
            payment_method: paymentMethod[3],
            tax: tax[0],
            agent_type: "",
            supplier: {
              name: "",
              inn: "",
              phone_numbers: "",
            },
          },
        ],
        description: "",
        proxy: false,
      },
      rules: {
        terminal_id: [
          { required: true, message: "Выберите терминал", trigger: "change" },
        ],
        amount: [
          {
            required: true,
            message: "Введите сумму",
            trigger: ["change", "blur"],
          },
          { validator: checkAmount, trigger: "blur" },
        ],
        merchant_order_id: [
          { required: true, message: "Введите номер заказа", trigger: "blur" },
        ],
        lifetime: [
          { required: false },
          { validator: checkLifetime, trigger: "blur" },
        ],
        email: [
          { required: false },
          { validator: checkEmail, trigger: "blur" },
        ],
        emailfz: [
          { required: true, message: "Введите email", trigger: "blur" },
          { validator: checkEmail, trigger: "blur" },
        ],
        full_name: [{ required: true, message: "Введите ФИО" }],
      },
      generalAmount: "",
      generatelink: "",
      generateVisible: false,
      ruToEn: {
        й: "q",
        ц: "w",
        у: "e",
        к: "r",
        е: "t",
        н: "y",
        г: "u",
        ш: "i",
        щ: "o",
        з: "p",
        ф: "a",
        ы: "s",
        в: "d",
        а: "f",
        п: "g",
        р: "h",
        о: "j",
        л: "k",
        д: "l",
        я: "z",
        ч: "x",
        с: "c",
        м: "v",
        и: "b",
        т: "n",
        ь: "m",
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() + 30 * 60 * 60 * 1000 <= Date.now();
        },
      },
      money: {
        decimal: ".",
        thousands: "",
        prefix: "",
        suffix: "",
        precision: 2,
      },
    };
  },
  methods: {
    showForm() {
      this.generateVisible = true;
      setTimeout(() => {
        this.$refs["form"].clearValidate();
      }, 0);
    },
    keyupAmount(event) {
      if (
        ((event.which != 46 || event.target.value.indexOf(".") != -1) &&
          (event.which < 48 || event.which > 57)) ||
        (event.which == 46 && event.target.selectionStart == 0)
      ) {
        event.preventDefault();
      }
    },
    changeRuToEn: function (str) {
      return enToRu[str] != undefined ? enToRu[str] : str;
      // return _.map(str, function (i) { return _.isUndefined(enToRu[str]) ? str : enToRu[str]; }).join("");
    },
    translate(e) {
      const pos = e.target.selectionStart;

      let text = this.form.merchant_order_id.toLowerCase();
      Object.entries(this.ruToEn).forEach(([ru, en]) => {
        const reg = new RegExp(ru, "g");
        text = text.replace(reg, en);
      });
      this.form.merchant_order_id = text;

      this.$nextTick(
        () => (e.target.selectionStart = e.target.selectionEnd = pos)
      );
    },
    onlyNumbers: function (e) {
      let regex = /[^0-9]/g;
      let key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
      if (regex.test(key)) {
        event.preventDefault();
        return false;
      }
    },
    onlyLetters: function (e) {
      let regex = /^[a-zA-Z а-яА-Я.]+$/;
      let key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
      if (!regex.test(key)) {
        event.preventDefault();
        return false;
      }
    },
    submitForm: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getLink();
        } else {
          return false;
        }
      });
    },
    getLink() {
      var params = {
        terminal_id: this.form.terminal_id,
        merchant_order_id: this.form.merchant_order_id,
        amount: Math.round(parseFloat(this.form.amount) * 100),
        proxy: this.form.proxy,
      };
      if (this.form.lifetime != "") {
        let lt = Math.round(new Date(this.form.lifetime).getTime() / 1000);
        let now = Math.round(Date.now() / 1000);
        if (lt > now) params.lifetime = lt - now;
      }
      if (this.terminalReceipt(this.form.terminal_id)) {
        if (this.form.emailfz != "")
          params.email = this.form.emailfz.toLowerCase();
      } else {
        if (this.form.email != "") params.email = this.form.email.toLowerCase();
      }
      if (this.form.full_name != "") params.full_name = this.form.full_name;
      if (this.form.description != "")
        params.description = this.form.description;
      if (
        this.form.goods.length > 0 &&
        this.terminalReceipt(this.form.terminal_id)
      ) {
        params.goods = this.form.goods.map((el, index) => {
          let {
            name,
            price,
            tax,
            subject_type,
            payment_method,
            supplier,
            agent_type,
          } = el;
          let { inn, phone_numbers } = supplier;
          let supplierName = supplier.name;
          let goods = {
            name,
            price: Math.round(parseFloat(price) * 100).toString(),
            tax: tax.id,
            payment_subject_type: subject_type.id,
            payment_method_type: payment_method.id,
          };
          if (agent_type) goods.agent_type = agent_type.value;
          let supp = {
            name: supplierName.replace(/["]/g, '\\"'),
            inn,
          };
          if (phone_numbers != "")
            supp.phone_numbers = phone_numbers.replace(/\s/g, "").split(",");

          if (supplierName && inn) goods.supplier = supp;

          return goods;
        });
        // this.form.goods.forEach((el, index) => {
        //   params.goods =
        //     params.goods +
        //     el.name +
        //     "=" +
        //     Math.round(parseFloat(el.price) * 100) +
        //     "," +
        //     el.subject_type.id +
        //     "," +
        //     el.tax.id +
        //     "," +
        //     el.payment_method.id +
        //     ";";
        // });
        // params.goods = params.goods.substring(0, params.goods.length - 1);
      }

      var config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token"),
        },
      };
      this.loading = true;
      axios
        .post(apiUrl + "payment-link/generate", params, config)
        .then(({ data }) => {
          if (data.state_id == 0) {
            this.$message({
              message: "Ссылка успешно создана",
              type: "success",
            });
            if (params.email != undefined) {
              if (data.email_sent == true) {
                this.$message({
                  message: "Ссылка отправлена на " + params.email,
                  type: "info",
                });
              } else {
                this.$message.error("Ошибка при отправке ссылки на email");
              }
            }
            this.url = data.url;
            this.isVisibleCopy = true;
          } else {
            this.$message.error("Ошибка при создании ссылки");
          }
        })
        .catch((err) => {
          this.$message.error("Неверные параметры. Повторите ввод данных");
        });
      this.loading = false;
    },
    addGoods() {
      this.form.goods.push({
        key: Date.now(),
        name: "",
        price: "",
        subject_type: subjectTypes[0],
        payment_method: paymentMethod[3],
        tax: tax[0],
        agent_type: "",
        supplier: {
          name: "",
          inn: "",
          phone_numbers: "",
        },
      });
    },
    removeGoods(item) {
      var index = this.form.goods.indexOf(item);
      if (index !== -1) {
        this.form.goods.splice(index, 1);
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      setTimeout(() => {
        this.$refs[formName].clearValidate();
      }, 0);
      this.isVisibleCopy = false;
      this.url = "";
      this.form.goods = [
        {
          key: Date.now(),
          name: "",
          price: "",
          subject_type: subjectTypes[0],
          payment_method: paymentMethod[3],
          tax: tax[0],
          agent_type: "",
          supplier: {
            name: "",
            inn: "",
            phone_numbers: "",
          },
        },
      ];
    },
    changeValue: function () {
      if (this.isVisibleCopy == true) this.isVisibleCopy = false;
    },
    handleClose: function (done) {
      this.resetForm("form");
    },
    doCopy: function () {
      this.$copyText(this.url).then(
        (_) => {
          this.$message("Ссылка скопирована");
        },
        function (e) {
          alert("Can not copy");
        }
      );
    },
    hideScroll() {
      document.documentElement.style.overflow = "hidden";
    },
    showScroll() {
      document.documentElement.style.overflow = "auto";
    },
    checkPrice(rule, value, callback) {
      let total = _.reduce(
        this.form.goods,
        (summ, el) => summ + Math.round(parseFloat(el.price) * 100),
        0
      );
      let amount = Math.round(parseFloat(this.form.amount) * 100);

      setTimeout(() => {
        if (parseFloat(value) <= 0) {
          return callback(new Error("Цена не должна быть равной нулю"));
        }
        if (amount != total) return callback(new Error("Суммы не совпадают"));
        callback();
      }, 300);
    },
    checkSupplierName(rule, value, callback) {
      let index = parseInt(rule.field.split(".")[1]);
      const { name } = this.form.goods[index].supplier;
      if (name === "")
        return callback(new Error("Поставщик должн быть заполнен"));
      else return callback();
    },

    checkSupplierINN(rule, value, callback) {
      let index = parseInt(rule.field.split(".")[1]);
      const { inn } = this.form.goods[index].supplier;

      if (inn.length !== 12 && inn.length !== 10) {
        if (inn !== "") {
          return callback(new Error("Введите корректный ИНН"));
        }
      }
      return callback()
    },
  },
  filters: {
    showLifeTime: function (value) {
      if (!value) return "";
      value = moment(value).fromNow();
      return value;
    },
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "merchantList",
      "merchantName",
      "terminalList",
      "terminalName",
      "terminalReceipt",
    ]),
    terminalNonPayout() {
      return this.terminalList.filter((el) => el.is_payout == false);
    },
  },
  components: {
    currencyInput,
  },
};
</script>

<style lang="sass"></style>
